module.exports = __webpack_public_path__ + "static/media/doctors10-150.5111ce21.webp";